import React, { useRef, useEffect } from 'react';
import { useViewport } from 'hooks/3catinfo/useViewport';
import styles from './modalNoLogat.module.scss';
import Boto from '../../../../components/3catinfo/Boto';
import Icona from '../../../../components/3catinfo/ui/Icona/Icona';
import clsx from 'clsx';
import { useUser } from '../../../../hooks/useUser';

const ModalNoLogat = ({ onClickClose, isVisibleModal }) => {
    const touchStartY = useRef(0);
    const touchEndY = useRef(0);
    const modalContentRef = useRef(null);
    const { zoomNavigator } = useViewport();

    const { signUp, signIn } = useUser();

    const handleTouchStart = (e) => {
        touchStartY.current = e.targetTouches[0].clientY;
    };

    const handleTouchMove = (e) => {
        touchEndY.current = e.targetTouches[0].clientY;
    };

    const handleTouchEnd = () => {
        if (touchEndY.current - touchStartY.current > 50) {
            onClickClose();
        }
    };

    const handleClickOutside = (e) => {
        if (modalContentRef.current && !modalContentRef.current.contains(e.target)) {
            onClickClose();
        }
    };

    const initialFocusRef = useRef(null);

    useEffect(() => {
        // Focus on the element referenced by initialFocusRef
        if (initialFocusRef.current) {
            initialFocusRef.current.focus();
        }
    }, []);

    const stylesWrapper = clsx({
        [styles.modal_wrapper]: true,
        [styles.visible]: isVisibleModal,
        [styles.ambZoom]: zoomNavigator > 3
    });

    return (
        <>
            <div className={styles.outside} onClick={onClickClose}>
                &nbsp;
            </div>
            <div className={styles.modal_mask} onClick={handleClickOutside}>
                <div className={stylesWrapper}>
                    <div className={styles.modal_content} ref={modalContentRef}>
                        <div
                            className={styles.slideDown}
                            onTouchStart={handleTouchStart}
                            onTouchMove={handleTouchMove}
                            onTouchEnd={handleTouchEnd}
                        ></div>
                        <button onClick={onClickClose} className={styles.tancar} ref={initialFocusRef}>
                            <Icona className={styles.iconaTancar} icona='tanca' alt='tanca' mida='32' />
                        </button>
                        <div className={styles.modal_scroll}>
                            <div className={styles.text_login_centered}>
                                <h2 className={styles.modal_titol}>Inicia sessió amb el teu compte 3Cat</h2>
                                <span className={styles.modal_text}>
                                    Per guardar-te notícies o seguir els temes i les firmes que t&#39;interessen
                                </span>
                                <div className={styles.buttons_login_centered}>
                                    <Boto
                                        tag='button'
                                        text='Inicia sessió'
                                        estil='ple3cat100'
                                        altIcona='Inicia sessió'
                                        dataTestId='areausuaris-inicia-sessio'
                                        onClick={() => signUp()}
                                        className={styles.boto}
                                    />
                                    <Boto
                                        tag='button'
                                        text='Crea el teu compte 3Cat'
                                        estil='lined3cat100'
                                        iconaInline={true}
                                        altIcona='Crea el teu compte 3Cat'
                                        dataTestId='areausuaris-crea-compte'
                                        onClick={() => signIn()}
                                    />
                                    <button onClick={onClickClose} className={styles.mestard}>
                                        Fes-ho més tard
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ModalNoLogat;
